/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr aktueller Standort`
};

const en_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `Your current location`
};

const es_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `Tu ubicación actual`
};

const fr_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `Votre position actuelle`
};

const it_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `La tua posizione attuale`
};

const nl_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `Uw huidige locatie`
};

const pt_itinerary__current_location = /** @type {(inputs: {}) => string} */ () => {
	return `A sua posição atual`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__current_location(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__current_location", locale)
	if (locale === "de") return de_itinerary__current_location(inputs)
	if (locale === "en") return en_itinerary__current_location(inputs)
	if (locale === "es") return es_itinerary__current_location(inputs)
	if (locale === "fr") return fr_itinerary__current_location(inputs)
	if (locale === "it") return it_itinerary__current_location(inputs)
	if (locale === "nl") return nl_itinerary__current_location(inputs)
	return pt_itinerary__current_location(inputs)
};